<script setup>
import debounce from 'debounce'
import { inject, onMounted, ref } from 'vue'
import { apolloClient } from 'boot/apollo'
import networkPartnersQuery from 'src/graphql/networkPartnersQuery.gql'
import AppSwiper from '#/general/AppSwiper'
import { useUtils } from 'src/composables/useUtils'

const { screen } = inject('Shared')
const { isVisible } = useUtils()
const networkPartners = ref(null)
const swiper = ref(0)

async function loadNetworkPartners () {
  try {
    const networkPartnersData = await apolloClient.query({
      query: networkPartnersQuery
    })
    networkPartners.value = JSON.parse(JSON.stringify(networkPartnersData?.data?.allNetworkPartners))
  } catch (e) {
    console.log(JSON.parse(JSON.stringify(e)))
  }
}

await loadNetworkPartners()

let checkAutoPlay = async () => {
  if (swiper.value && swiper.value.running) {
    const visible = isVisible(document.getElementById('b2cPartnerSwiper'))
    if (visible) {
      swiper.value.autoplay.run()
    } else {
      swiper.value.autoplay.running = false
    }
  }
}
checkAutoPlay = debounce(checkAutoPlay, 300)

onMounted(async () => {
  window.addEventListener('scroll', async () => {
    checkAutoPlay()
  })
})
</script>

<template lang="pug">
.b2c-partners-container
  .routerPageSize(v-if="networkPartners")
    .b2c-partners--title
      strong Raumpioniere
      div haben starke Partner.
    .b2c-partners--subtitle-container
      .b2c-partners--subtitle
        span Immer mehr renommierte Institutionen und Unternehmen aus der Welt des Planens und Bauens unterstützen die Mission von uns
        strong &#32; Raumpionieren. &#32;
    .b2c-partners
      .b2c-partners--container
        .b2c-partners--shadow-left
        .b2c-partners--shadow-right
        app-swiper.b2c-partners--carousel#b2cPartnerSwiper(
          :initial-slide="0"
          :items="networkPartners"
          :slides-per-view="'auto'"
          :gabCursor="true"
          :speed="3000"
          :centered-slides="true"
          @swiper="swiper = $event; swiper.touch = true"
          :loop="true"
          :space-between="screen.gt.xs ? 50 : 20"
          :free-mode="true"
          :autoplay="{ delay: 1, disableOnInteraction: false, pauseOnMouseEnter: true, waitForTransition: false }"
        )
          template(#item="props")
            .b2c-partners--img-container
              a(:href="props.item.website" target="_blank")
                img.b2c-partners--img(v-if="props.item" v-lazy="{ src: `https://raumpionierestorage.blob.core.windows.net/images/${props.item.logo}` }")
</template>

<style lang="sass">
.swiper-wrapper
  -webkit-transition-timing-function: linear !important
  -o-transition-timing-function: linear !important
  transition-timing-function: linear !important

.b2c-partners-container
  display: flex
  align-items: center
  flex-direction: column
  width: 100%
  @media screen and (min-width: 1024px)
    padding-bottom: 180px
  @media screen and (max-width: 1024px)
  .b2c-partners--title
    font-weight: 400
    font-size: 55px
    line-height: 130%
    text-align: center
    color: #22223C
    @media screen and (min-width: 1024px)
      margin-bottom: 70px
    @media screen and (max-width: 1024px)
      padding-bottom: 35px
      font-size: 30px
  .b2c-partners--subtitle-container
    width: 100%
    display: flex
    justify-content: center
    align-items: center
    .b2c-partners--subtitle
      font-weight: 400
      font-size: 21px
      line-height: 150%
      text-align: center
      color: #22223C
      max-width: 872px
      @media screen and (max-width: 1024px)
        font-size: 16px
        padding-bottom: 20px
  .b2c-partners
    padding: 175px 15px 0 15px
    display: flex
    flex-direction: column
    align-items: center
    @media screen and (max-width: 1024px)
      padding: 60px 15px 0 15px
  .b2c-partners
    width: 100%
    @media screen and (max-width: 1024px)
      margin-bottom: 30px
    .b2c-partners--container
      display: flex
      width: 100%
      position: relative
      .b2c-partners--shadow-left
        position: absolute
        top: 0
        left: -1px
        height: 100%
        z-index: 10
        background: linear-gradient(to right, rgba(255, 255, 255, 1) 26.84%, rgba(217, 217, 217, 0) 100%, rgba(247, 247, 247, 0.799465) 100%)
        @media screen and (min-width: 1024px)
          width: 200px
        @media screen and (max-width: 1024px)
          width: 50px
      .b2c-partners--shadow-right
        position: absolute
        top: 0
        right: -1px
        background: linear-gradient(to left, rgba(255, 255, 255, 1) 26.84%, rgba(217, 217, 217, 0) 100%, rgba(247, 247, 247, 0.799465) 100%)
        height: 100%
        z-index: 10
        @media screen and (min-width: 1024px)
          width: 200px
        @media screen and (max-width: 1024px)
          width: 50px
      .b2c-partners--carousel
        .swiper-slide
          padding: 0 20px
          width: auto
          height: 53px
          .b2c-partners--img-container
            align-items: center
            display: flex
            justify-content: center
            @media screen and (max-width: 1024px)
              max-height: 150px
            a
              display: flex
              align-items: center
              .b2c-partners--img
                -webkit-filter: grayscale(100%)
                filter: grayscale(100%)
                width: auto
                object-fit: cover
                @media screen and (min-width: 1024px)
                  height: 53px
                @media screen and (max-width: 1024px)
                  height: 43px
      .swiper-centered
        .swiper
          .swiper-wrapper
            justify-content: center
</style>
